module.exports = __webpack_public_path__ + "img/guide-14.5dffd571.jpg";